import Base from './Base'
import gsap from 'gsap'

import { evt, utils, store } from '@/core'

const { qs, qsa } = utils
const { dom, bounds } = store

export default class extends Base {
	onEnter() {
		super.onEnter()
	}

	onLeave() {
		super.onLeave()
	}

	onEnterCompleted() {
		super.onEnterCompleted()	
		this.handleTimelineScrollRail();
	}

	onLeaveCompleted() {
		super.onLeaveCompleted()
	}
	handleTimelineScrollRail() {
		console.log('ale')
		let tl = gsap
		  .timeline({
			immediateRender: false,
			scrollTrigger: {
			  trigger: ".timeline",
			  start: "top top",
			  end: "bottom bottom",
			  scrub: true,
			  invalidateOnRefresh: true,
			},
		  })
		  .fromTo(
			"#misc-timeline",
			{ yPercent: -2 },
			{ yPercent: -54, duration: 8, ease: "none" },
			0
		  )
		  .fromTo(
			"#misc-timeline-2",
			{ yPercent: 0 },
			{ yPercent: -62, duration: 8, ease: "none" },
			"<-=0.2"
		  );
	}
}